import { FC, ReactNode } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { IconBox } from '../IconBox'

interface AppPageHeaderProps {
  title: string
  subtitle: string
  icon: ReactNode
}

export const AppPageHeader: FC<AppPageHeaderProps> = ({ title, subtitle, icon }) => (
  <Flex align="flex-start" justify="space-between" gap={4} mb="18px" flexWrap="wrap">
    <Flex align="center" gap={3} flex="1" minW="280px">
      <IconBox
        boxSize={38}
        iconSize={18}
        borderRadius="10px"
        bgGradient="linear(to-br, blue.600, blue.800)"
      >
        {icon}
      </IconBox>
      <Box>
        <Text as="h1" fontSize="20px" fontWeight="bold" color="gray.800" mb="2px" lineHeight="1.2">
          {title}
        </Text>
        <Text fontSize="13px" color="gray.400" lineHeight="1.4">
          {subtitle}
        </Text>
      </Box>
    </Flex>
  </Flex>
)
